module.exports = __webpack_public_path__ + "static/media/Mindfully_Regular_Italic.a05fae7b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Mindfully_Regular_Italic.ttf
// module id = 1818
// module chunks = 50